// Default width for the sidebar
export const SIDEBAR_DEFAULT_WIDTH = 328; // 20.5rem

// Minimum width for the sidebar
export const SIDEBAR_MIN_WIDTH = 64; // 4rem

// Maximum width for the sidebar
export const SIDEBAR_MAX_WIDTH = 40 * 16; // 40rem

// Maximum width for the sidebar on mobile (when width is reached and decreases, the sidebar will be collapsed visually)
export const SIDEBAR_MOBILE_MAX_WIDTH = 160; // 12.5rem

// Default height for a chat row
export const DEFAULT_CHAT_ROW_HEIGHT = 36;

// Default height for a chat row of another user
export const DEFAULT_OTHER_USER_CHAT_ROW_HEIGHT = 52;

/** Flex grow for the main chat list vs expanded accordion panels in the sidebar. */
export const SIDEBAR_CHAT_LIST_FLEX_GROW = 3;
export const SIDEBAR_ACCORDION_FLEX_GROW = 2;

/** Max share of the chat list column height reserved for pinned chats. */
export const PINNED_CHATS_MAX_HEIGHT_PERCENT = 32;

export enum SIDEBAR_TAB_TYPES {
    all = "all",
    pinned = "pinned",
    shared = "shared"
}

// Sidebar "Filter chat history" panel (SidebarFilterAction / SidebarFilterPanel)

export enum SIDEBAR_FILTER_SORT_BY {
    lastActivity = "last_activity",
    dateCreated = "date_created",
    nameAsc = "name_asc",
}

export enum SIDEBAR_FILTER_LAST_ACTIVE {
    any = "any",
    last7Days = "last_7_days",
    last30Days = "last_30_days",
}

/** Display labels shared between the filter panel (SidebarFilterPanel) and the
 * applied-filters summary shown on the SidebarFilterAction tooltip. */
export const SIDEBAR_FILTER_SORT_BY_LABELS: Record<SIDEBAR_FILTER_SORT_BY, string> = {
    [SIDEBAR_FILTER_SORT_BY.lastActivity]: "Last activity",
    [SIDEBAR_FILTER_SORT_BY.dateCreated]: "Date created",
    [SIDEBAR_FILTER_SORT_BY.nameAsc]: "Name (A-Z)",
};

export const SIDEBAR_FILTER_LAST_ACTIVE_LABELS: Record<SIDEBAR_FILTER_LAST_ACTIVE, string> = {
    [SIDEBAR_FILTER_LAST_ACTIVE.any]: "Any time",
    [SIDEBAR_FILTER_LAST_ACTIVE.last7Days]: "Last 7 days",
    [SIDEBAR_FILTER_LAST_ACTIVE.last30Days]: "Last 30 days",
};

export interface ISidebarFilters {
    sortBy: SIDEBAR_FILTER_SORT_BY;
    chatTypes: string[]; // keys from SIDEBAR_CHAT_TYPE_OPTIONS
    lastActive: SIDEBAR_FILTER_LAST_ACTIVE;
    hideClosedChats: boolean; // false (default) shows open + closed chats, true shows only open chats (see utils/chatClosed)
}

export const DEFAULT_SIDEBAR_FILTERS: ISidebarFilters = {
    sortBy: SIDEBAR_FILTER_SORT_BY.lastActivity,
    chatTypes: [],
    lastActive: SIDEBAR_FILTER_LAST_ACTIVE.any,
    hideClosedChats: false,
};

/** Key for chats whose tags don't match any of the other chat-type options below. */
export const GENERAL_CHAT_TYPE_KEY = "general";

/** Chat-type checkboxes shown in the filter panel, mapped to the underlying
 * chat.tags values (see config/channels.tsx) that identify each type.
 * "General chat" has no tags of its own — it matches chats whose tags don't
 * fall into any of the other buckets (handled in sidebarFilterHelper). */
export const SIDEBAR_CHAT_TYPE_OPTIONS: { key: string; label: string; tags: string[] }[] = [
    { key: GENERAL_CHAT_TYPE_KEY, label: "General chat", tags: [] },
    { key: "claim-review", label: "Claim review", tags: ["claim-review", "revise-rejected-claim"] },
    { key: "appeal", label: "Appeal", tags: ["appeal-claim", "appeal-letters"] },
    { key: "policy-questions", label: "Policy question", tags: ["policy-questions"] },
    { key: "contract-research", label: "Contract research", tags: ["contract-research"] },
    { key: "pre-service-review", label: "Pre-service review", tags: ["pre-service-review"] },
];